export default __webpack_public_path__ + "static/media/profileActive.830d3626.svg";